export default __webpack_public_path__ + "static/media/kidneyshots.99d10fca.png";